import { StringValues } from '../interfaces/undetermined';

// Constante que guarda el nombre de los atributos que reciben los servicios del API de entidades
export const ENTITY: StringValues = {
    operation: "ope",
    agreement: "cnv",
};
